import { render, staticRenderFns } from "./OfficialExams.vue?vue&type=template&id=34e278da"
import script from "./OfficialExams.vue?vue&type=script&lang=js"
export * from "./OfficialExams.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports